import React from 'react';
import PropTypes from 'prop-types'; ;

import {Grid, Typography, Paper, Container, screenSizeSmaller} from 'views/components';

import {Translate} from 'views/module';
import {Helmet} from 'views/module';

const InternalServerError = (props) => {
  const [showErrorLog, setShowErrorLog] = React.useState(false);

  const smallSize = screenSizeSmaller('sm');

  const error = props.error;

  // on 'e' toggle error log
  React.useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'e') {
        setShowErrorLog((prev) => !prev);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  if (showErrorLog) {
    return (
      <Container maxWidth={false} disableGutters sx={{'backgroundColor': 'background.main'}}>
        <Container
          className="App"
          disableGutters
          maxWidth={false}
          sx={{maxWidth: '1440px'}}
        >
          <Paper
            elevation={0}
            sx={
              {
                'padding': smallSize ? '4px' : '16px',
                'minHeight': smallSize ? '100vh' : '95vh',
                'backgroundColor': 'background.main',
              }
            }
          >
            <Paper sx={{mt: {xs: '20px', sm: '40px'}, mx: {xs: '16px', sm: 0}, py: '24px', px: {xs: '16px', sm: 0}}}>
              <Grid container spacing={2} sx={{p: 1}}>
                <Grid size={12}>
                  <Grid container>
                    <Grid size={12} sx={{display: 'flex', justifyContent: 'center'}}>
                      <Typography sx={{fontWeight: 'bold'}}>
                        <Translate expression='error.ErrorMessage'/>
                      </Typography>
                    </Grid>
                    <Grid size={12} sx={{display: 'flex', justifyContent: 'center'}}>
                      <Typography>
                        {error.message}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={12}>
                  <Grid container>
                    <Grid size={12} sx={{display: 'flex', justifyContent: 'center'}}>
                      <Typography sx={{fontWeight: 'bold'}}>
                        <Translate expression='error.StackTrace'/>
                      </Typography>
                    </Grid>
                    <Grid size={12} sx={{display: 'flex', justifyContent: 'center'}}>
                      <Typography component='div'>
                        <pre style={{fontFamily: 'inherit'}}>
                          {error.stack}
                        </pre>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Paper>
        </Container >
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>Quilt: Internal Server Error</title>
      </Helmet>
      <Container maxWidth={false} disableGutters sx={{'backgroundColor': 'background.main'}}>
        <Container
          className="App"
          disableGutters
          maxWidth={false}
          sx={{maxWidth: '1440px'}}
        >
          <Paper
            elevation={0}
            sx={
              {
                'padding': smallSize ? '4px' : '16px',
                'minHeight': smallSize ? '100vh' : '95vh',
                'backgroundColor': 'background.main',
              }
            }
          >
            <Paper sx={{mt: {xs: '20px', sm: '40px'}, mx: {xs: '16px', sm: 0}, py: '24px', px: {xs: '16px', sm: 0}}}>
              <Grid container spacing={2}>
                <Grid size={12} sx={{display: 'flex', justifyContent: 'center'}}>
                  <Typography sx={{
                    fontSize: '64px',
                    fontWeight: 900,
                    color: 'primary.main',
                  }}>
                    <Translate expression='error.OopsSomethingWentWrong'/>
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Grid container justifyContent='center' textAlign='left'>
                    <Grid>
                      <Typography sx={{
                        textAlign: 'center',
                        fontSize: '32px',
                      }}>
                        <Translate expression='error.HereAreSteps'/>
                      </Typography>
                      <ol>
                        <li key={0}>
                          <Typography>
                            <Translate expression='error.RefreshThePage'/>
                          </Typography>
                        </li>
                        <li key={1}>
                          <Typography>
                            <a href='/signout'>
                              <Translate expression='error.SignOut'/>
                            </a>
                            <Translate expression='error.AndSignInAgain'/>
                          </Typography>
                        </li>
                        <li key={2}>
                          <Typography>
                            <Translate expression='error.PleaseComeBackLater'/>
                          </Typography>
                        </li>
                        <li key={3}>
                          <Typography>
                            <Translate expression='error.PleaseContact'/> <a href={`mailto:info@carequilt.ca`}>info@Quilt.com</a>
                          </Typography>
                        </li>
                      </ol>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Paper>
        </Container >
      </Container>
    </>
  );
};
InternalServerError.propTypes = {
  error: PropTypes.object.isRequired,
};

export default React.memo(InternalServerError);
